@import '../../../../constants/spacing.module.less';

.dropdown-inline-message {
  display: flex;
  align-items: center;
  gap: @space-4;
}

.inline-message {
  flex: 1;
}

.icon {
  width: 16px;
  height: 16px;
}

.is-error {
  color: var(--error--message--text-color--1);
}

.is-warning {
  color: var(--warning--message--text-color--2);
}

.is-info {
  color: var(--primary--message--text-color--6);
}
